import React, { useState,useEffect} from "react";
import styles from "./tabs.module.css";
import { Link } from "react-router-dom";
import SecondaryTooltip from "../secondaryToolTip/secondaryToolTip";
 
 
export const Tabs = (props) => {
    const [activeTab, setActiveTab] = useState(props.defaultActiveTab);
    
    useEffect(() => {
        props.getActiveTab(activeTab);        
    }, [activeTab]);

    useEffect(() => {
        setActiveTab(props.defaultActiveTab);
    }, [props.defaultActiveTab]);

    const handleTab = (key) => {
        setActiveTab(key);      
    }
   
    const filteredTabOptions = props.option.filter(tab => tab.canAccess);
 
    return (
        <div className={styles.conatiner}>
            {
                filteredTabOptions.map((item,index) => {
                    let _class = `${styles.item}`
                    if (activeTab === item.key) {
                        _class = `${styles.item} ${styles.active}`
                    }
                    return (
                        <Link key={index} className={_class} to={item?.routeUrl} onClick={() => handleTab(item.key)}>
                             {item.label} {item.count &&<span className={styles.count}><SecondaryTooltip text={item?.count} positions={['bottom', 'right']}>{item?.count > 99 ? '99+' : item?.count}</SecondaryTooltip></span>}
                        </Link>
                    )
                })
            }
        </div>
    )
}